// extracted by mini-css-extract-plugin
export default {"delete":"Uvjj7","button":"jTpHf"};